<template>
    <div class="app-body-1160px transparent">
      <!-- 标题 -->
      <ModuleHeader title="万物有灵" detail="可能是迄今为止最强的万物版本"></ModuleHeader>
      <!-- 主体 -->
      <div id="app-everything-body">
        <!-- 轮播图 -->
        <div id="app-everything-carousel">
          <el-carousel :interval="4000" trigger="click" arrow="always" height="325px">
            <el-carousel-item v-for="item in imgList" :key="item.id">
              <img :src='item.url' class="main-body-carousel-img" alt="pic"/>
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- 右边的按钮 -->
        <div id="app-everything-right-null">
          <ul>
            <li style="float:left;" v-for="item in index" :key="item.id">
              <el-card class="app-everything-right-card">
                <em class="el-icon-star-off app-everything-right-card-icon"></em>
                <div class="app-everything-right-card-p">{{ item.name }}</div>
              </el-card>
            </li>
          </ul>
          <div style="clear:both;"></div>
        </div>
      </div>
    </div>
</template>

<script>
import ModuleHeader from "@/views/share/home/ModuleHeader";

export default {
  name: "EveryThing",
  components: {
    ModuleHeader
  },
  data() {
    return {
      index: [
        {
          name: '效率革命',
        },
        {
          name: '一键预览',
        },
        {
          name: '底层优化',
        },
        {
          name: '底层优化',
        },
        {
          name: '无限扩展',
        },
        {
          name: '人工智能',
        }
      ],
      imgList: [
        {
          url: 'https://img.blendermagic.cn/new/everything/everythingCarousel1.jpg',
        },
        {
          url: 'https://img.blendermagic.cn/new/everything/everythingCarousel2.jpg',
        },
        {
          url: 'https://img.blendermagic.cn/new/everything/everythingCarousel3.jpg',
        }
      ]
    }
  }
}
</script>

<style scoped>

#app-everything-body {
  position: relative;
  padding-bottom: 50px;
}

#app-everything-carousel {
  width: 935px;
  height: 325px;
}

#app-everything-right-null {
  position: absolute;
  left: 935px;
  right: 0;
  top: 0;
  height: 325px;
  /*background: #ff8a00;*/
}

.app-everything-right-card {
  position: relative;
  margin-left: 10px;
  margin-bottom: 10px;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.app-everything-right-card-icon {
  font-size: 50px;
  padding-top: 10px;
  margin: auto;
}

.app-everything-right-card-p {
  position: absolute;
  bottom: -30px;
  width: 100%;
}

</style>